import Relay from 'react-relay';

export default class AddFrontfacerMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{addFrontFacer}`;
  }

  getVariables() {
    return {
      name: this.props.name,
      picture: this.props.picture,
      agentId: this.props.agentId,
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on AddFrontFacerPayload {
        agent {
          frontFacers
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        agent: this.props.agentRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/AddFrontfacerMutation.js
 **/